/* This hook behaves similarly to useEffect, except that it
executes the function passed in only after the component first
render. Its usage is the same as the useEffect hook. */

import { useEffect, useRef } from 'react'

const useDidMountEffect = (func, deps) => {
  const didMount = useRef(false)

  useEffect(() => {
    if (didMount.current) func()
    else didMount.current = true
  }, deps)
}

export default useDidMountEffect
